module.exports = __webpack_public_path__ + "img/5_43.6843456e.png";